import type { FieldError } from 'react-hook-form';

export const getTextError = (isSubmitted: boolean, isTouched: boolean, error?: FieldError): string | undefined => {
  if ((isTouched || isSubmitted) && error?.message) {
    return error?.message;
  }
  return undefined;
};
